import * as React from 'react';
import { observer } from 'mobx-react';

import { SignalRConnectionState, signalRService } from '@app/Services/SignalRService';

const STATE_TITLE: Record<SignalRConnectionState, string> = {
    connected: 'Online',
    reconnecting: 'Not connected, reconnecting...'
};

type ConnectionStatusProps = {
    className?: string;
    isCollapsed?: boolean;
};

@observer
export class ConnectionStatus extends React.Component<ConnectionStatusProps> {
    render() {
        const { className = '', isCollapsed } = this.props;
        const state = signalRService.connectionState;
        const shape = isCollapsed ? 'arc' : 'bar';

        return (
            <span
                className={`connection-status connection-status-${shape} connection-status-${state} ${className}`}
                title={STATE_TITLE[state]}
            />
        );
    }
}
